// components/TotalSummary.jsx
import React from 'react';
import { Grid, FormControl, InputLabel, FilledInput, InputAdornment } from '@mui/material';
import { currencyFormatter } from './CurrencyFormat';

const TotalSummaryComponent = ({ fields = [] }) => {
    const columnsPerRow = (fields.length > 6 ? 4 : (fields.length == 4 ? 4 : 3));

    return (
        <Grid container spacing={2} sx={{ mt: 2 }}>
            {fields.map(({ id, label, value }, index) => (
                <Grid key={id || index} item xs={12} sm={12 / Math.min(fields.length, columnsPerRow)}>
                    <FormControl fullWidth variant="filled">
                        <InputLabel htmlFor={id} style={{ fontSize: "18px" }}>
                            <strong>{label}</strong>
                        </InputLabel>
                        <FilledInput
                            id={id}
                            startAdornment={<InputAdornment position="start">€</InputAdornment>}
                            value={currencyFormatter(value)}
                            readOnly
                        />
                    </FormControl>
                </Grid>
            ))}
        </Grid>
    );
};

export default TotalSummaryComponent;
